module.exports = __webpack_public_path__ + "img/img (17).9309f66f.png";